import api from './api';

export const authApi = {
  login: (email, password) =>
    api.post('/auth/login', { email, password, userType: 'client_user' }).then((r) => r.data),
  profile: () => api.get('/auth/profile').then((r) => r.data),
  logout: () => api.post('/auth/logout').then((r) => r.data),
  changePassword: (currentPassword, newPassword) =>
    api.post('/auth/change-password', { currentPassword, newPassword }).then((r) => r.data),
  forgotPassword: (email) =>
    api
      .post('/auth/forgot-password', { email, userType: 'client_user', appUrl: window.location.origin })
      .then((r) => r.data),
  updateProfile: (payload) => api.patch('/auth/profile', payload).then((r) => r.data),
  resetPassword: (token, newPassword) =>
    api.post('/auth/reset-password', { token, newPassword, userType: 'client_user' }).then((r) => r.data)
};

export const portalApi = {
  me: () => api.get('/portal/me').then((r) => r.data),
  locations: () => api.get('/portal/locations').then((r) => r.data),
  statsOverview: (params) => api.get('/portal/stats/overview', { params }).then((r) => r.data),
  analytics: (params) => api.get('/portal/analytics', { params }).then((r) => r.data),
  calls: (params) => api.get('/portal/calls', { params }).then((r) => r.data),
  call: (id) => api.get(`/portal/calls/${id}`).then((r) => r.data),
  callRecording: (id) => api.get(`/portal/calls/${id}/recording`).then((r) => r.data),
  updateCall: (id, payload) => api.patch(`/portal/calls/${id}`, payload).then((r) => r.data),
  resolveCall: (id) => api.post(`/portal/calls/${id}/resolve`).then((r) => r.data),
  agents: () => api.get('/portal/agents').then((r) => r.data),
  updateAgent: (id, payload) => api.patch(`/portal/agents/${id}`, payload).then((r) => r.data),
  clients: (params) => api.get('/portal/clients', { params }).then((r) => r.data),
  updateClient: (id, payload) => api.patch(`/portal/clients/${id}`, payload).then((r) => r.data),
  client: (id) => api.get(`/portal/clients/${id}`).then((r) => r.data),
  createClient: (payload) => api.post('/portal/clients', payload).then((r) => r.data),
  removeClient: (id) => api.delete(`/portal/clients/${id}`).then((r) => r.data),
  addClientNote: (id, text) => api.post(`/portal/clients/${id}/notes`, { text }).then((r) => r.data),
  maintenance: (params) => api.get('/portal/maintenance', { params }).then((r) => r.data),
  updateMaintenanceTicket: (id, payload) =>
    api.patch(`/portal/maintenance/tickets/${id}`, payload).then((r) => r.data),
  createMaintenanceTicket: (payload) =>
    api.post('/portal/maintenance/tickets', payload).then((r) => r.data),
  removeMaintenanceTicket: (id) => api.delete(`/portal/maintenance/tickets/${id}`).then((r) => r.data),
  addMaintenanceNote: (id, text) =>
    api.post(`/portal/maintenance/tickets/${id}/notes`, { text }).then((r) => r.data),
  createRecurring: (payload) => api.post('/portal/maintenance/recurring', payload).then((r) => r.data),
  updateRecurring: (id, payload) => api.patch(`/portal/maintenance/recurring/${id}`, payload).then((r) => r.data),
  removeRecurring: (id) => api.delete(`/portal/maintenance/recurring/${id}`).then((r) => r.data),
  updateNotifications: (payload) => api.patch('/portal/notifications', payload).then((r) => r.data),
  updateBranding: (payload) => api.patch('/portal/branding', payload).then((r) => r.data),
  bookings: (params) => api.get('/portal/bookings', { params }).then((r) => r.data),
  createBooking: (payload) => api.post('/portal/bookings', payload).then((r) => r.data),
  updateBooking: (id, payload) => api.patch(`/portal/bookings/${id}`, payload).then((r) => r.data),
  bookingAssignees: () => api.get('/portal/bookings/assignees').then((r) => r.data),
  businessHours: () => api.get('/portal/business-hours').then((r) => r.data),
  updateBusinessHours: (payload) => api.put('/portal/business-hours', payload).then((r) => r.data),
  onCall: () => api.get('/portal/oncall').then((r) => r.data),
  updateOnCall: (payload) => api.put('/portal/oncall', payload).then((r) => r.data),
  knowledge: () => api.get('/portal/knowledge').then((r) => r.data),
  createKnowledge: (payload) => api.post('/portal/knowledge', payload).then((r) => r.data),
  updateKnowledge: (id, payload) => api.put(`/portal/knowledge/${id}`, payload).then((r) => r.data),
  removeKnowledge: (id) => api.delete(`/portal/knowledge/${id}`).then((r) => r.data),
  testKnowledge: (query) => api.post('/portal/knowledge/test', { query }).then((r) => r.data),
  uploadKnowledge: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post('/portal/knowledge/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
  },
  updateScheduling: (payload) => api.patch('/portal/scheduling', payload).then((r) => r.data),
  schedulingAvailability: (params) => api.get('/portal/scheduling/availability', { params }).then((r) => r.data),

  // SMS inbox
  messages: (params) => api.get('/portal/messages', { params }).then((r) => r.data),
  messageThread: (contactNumber) =>
    api.get(`/portal/messages/${encodeURIComponent(contactNumber)}`).then((r) => r.data),
  sendMessage: (contactNumber, body) =>
    api.post('/portal/messages', { contactNumber, body }).then((r) => r.data),
  resolveConversation: (contactNumber) =>
    api.post(`/portal/messages/${encodeURIComponent(contactNumber)}/resolve`).then((r) => r.data),
  suggestReply: (contactNumber) =>
    api.post('/portal/messages/suggest', { contactNumber }).then((r) => r.data),
  contactList: (params) => api.get('/portal/contacts', { params }).then((r) => r.data),
  contactContext: (contactNumber) =>
    api.get(`/portal/contacts/${encodeURIComponent(contactNumber)}`).then((r) => r.data),

  // Message templates
  messageTemplates: () => api.get('/portal/message-templates').then((r) => r.data),
  createMessageTemplate: (payload) =>
    api.post('/portal/message-templates', payload).then((r) => r.data),
  updateMessageTemplate: (id, payload) =>
    api.patch(`/portal/message-templates/${id}`, payload).then((r) => r.data),
  removeMessageTemplate: (id) =>
    api.delete(`/portal/message-templates/${id}`).then((r) => r.data),
  useMessageTemplate: (id) =>
    api.post(`/portal/message-templates/${id}/use`).then((r) => r.data),

  // Messaging settings (Smart Reply, auto-reply, quiet hours, compliance)
  messagingSettings: () => api.get('/portal/messaging-settings').then((r) => r.data),
  updateMessagingSettings: (payload) =>
    api.patch('/portal/messaging-settings', payload).then((r) => r.data),

  // Rental listings
  listings: (params) => api.get('/portal/listings', { params }).then((r) => r.data),
  listing: (id) => api.get(`/portal/listings/${id}`).then((r) => r.data),
  addListingNote: (id, text) => api.post(`/portal/listings/${id}/notes`, { text }).then((r) => r.data),
  createListing: (payload) => api.post('/portal/listings', payload).then((r) => r.data),
  updateListing: (id, payload) => api.patch(`/portal/listings/${id}`, payload).then((r) => r.data),
  removeListing: (id) => api.delete(`/portal/listings/${id}`).then((r) => r.data),

  vendors: (params) => api.get('/portal/vendors', { params }).then((r) => r.data),
  vendorsSummary: () => api.get('/portal/vendors/summary').then((r) => r.data),
  vendor: (id) => api.get(`/portal/vendors/${id}`).then((r) => r.data),
  createVendor: (payload) => api.post('/portal/vendors', payload).then((r) => r.data),
  updateVendor: (id, payload) => api.patch(`/portal/vendors/${id}`, payload).then((r) => r.data),
  removeVendor: (id) => api.delete(`/portal/vendors/${id}`).then((r) => r.data),
  owners: (params) => api.get('/portal/owners', { params }).then((r) => r.data),
  owner: (id) => api.get(`/portal/owners/${id}`).then((r) => r.data),
  createOwner: (payload) => api.post('/portal/owners', payload).then((r) => r.data),
  updateOwner: (id, payload) => api.patch(`/portal/owners/${id}`, payload).then((r) => r.data),
  removeOwner: (id) => api.delete(`/portal/owners/${id}`).then((r) => r.data),
  uploadOwnerFile: (id, file, type) => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('type', type);
    return api.post(`/portal/owners/${id}/files`, fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
  },
  ownerFile: (id, fileId) => api.get(`/portal/owners/${id}/files/${fileId}`, { responseType: 'blob' }).then((r) => r.data),
  deleteOwnerFile: (id, fileId) => api.delete(`/portal/owners/${id}/files/${fileId}`).then((r) => r.data),
  actions: (params) => api.get('/portal/tasks', { params }).then((r) => r.data),
  action: (id) => api.get(`/portal/tasks/${id}`).then((r) => r.data),
  actionStep: (id, step, payload) => api.post(`/portal/tasks/${id}/${step}`, payload).then((r) => r.data),
  conversationMode: (contactNumber) => api.get(`/portal/conversations/${encodeURIComponent(contactNumber)}/mode`).then((r) => r.data),
  setConversationMode: (contactNumber, mode) =>
    api.post(`/portal/conversations/${encodeURIComponent(contactNumber)}/mode`, { mode }).then((r) => r.data),
  handOff: (payload) => api.post('/portal/handoffs', payload).then((r) => r.data),
  flagCall: (id, payload) => api.post(`/portal/calls/${id}/flag`, payload).then((r) => r.data),

  teamPermissions: () => api.get('/portal/users/permissions').then((r) => r.data),
  team: () => api.get('/portal/users').then((r) => r.data),
  inviteUser: (payload) => api.post('/portal/users', payload).then((r) => r.data),
  updateUser: (id, payload) => api.patch(`/portal/users/${id}`, payload).then((r) => r.data),
  resetUserPassword: (id) => api.post(`/portal/users/${id}/reset-password`).then((r) => r.data),
  removeUser: (id) => api.delete(`/portal/users/${id}`).then((r) => r.data),

  // Prospects (leasing pipeline)
  prospects: (params) => api.get('/portal/prospects', { params }).then((r) => r.data),
  createProspect: (payload) => api.post('/portal/prospects', payload).then((r) => r.data),
  updateProspect: (id, payload) => api.patch(`/portal/prospects/${id}`, payload).then((r) => r.data),
  removeProspect: (id) => api.delete(`/portal/prospects/${id}`).then((r) => r.data),
  bookProspectTour: (id, start) => api.post(`/portal/prospects/${id}/tour`, { start }).then((r) => r.data),
  convertProspect: (id, payload) => api.post(`/portal/prospects/${id}/convert`, payload).then((r) => r.data)
};
